
/**
 * 인증 제공자
 */
export type GetAllUsers200ContentItemProvider = typeof GetAllUsers200ContentItemProvider[keyof typeof GetAllUsers200ContentItemProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAllUsers200ContentItemProvider = {
  LOCAL: 'LOCAL',
  GOOGLE: 'GOOGLE',
  GITHUB: 'GITHUB',
  FACEBOOK: 'FACEBOOK',
} as const;
